import {
  ChangeDetectionStrategy,
  Component,
  DestroyRef,
  inject,
  Input,
  OnInit,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import {
  ControlContainer,
  FormGroup,
  ReactiveFormsModule,
} from '@angular/forms';
import { ServiceDataFields } from '@app/modules/service-data/components/service-data/service-data-form/field-sets/service-data-fields.enum';
import { TranslateModule } from '@ngx-translate/core';
import { ValidationErrorComponent } from '@shared/components/validation-error/validation-error.component';
import { controlContainerProvider } from '@shared/helpers';

@Component({
  selector: 'app-service-data-form-vanishing-twin-syndrome',
  imports: [TranslateModule, ValidationErrorComponent, ReactiveFormsModule],
  templateUrl: './service-data-form-vanishing-twin-syndrome.component.html',
  viewProviders: [controlContainerProvider],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ServiceDataFormVanishingTwinSyndromeComponent implements OnInit {
  private controlContainer = inject(ControlContainer);

  @Input({ required: true }) fieldSet: string[];
  protected get form() {
    return this.controlContainer.control as FormGroup;
  }

  private destroyRef = inject(DestroyRef);

  ngOnInit(): void {
    this.form
      .get('vanishingTwinSyndrome.isDetected')
      .valueChanges.pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((vanishingTwinSyndrome: boolean) => {
        if (!vanishingTwinSyndrome) {
          this.form
            .get('vanishingTwinSyndrome.detectedGestationAge.day')
            .reset(null);
          this.form
            .get('vanishingTwinSyndrome.detectedGestationAge.week')
            .reset(null);
        }
      });
  }

  protected readonly ServiceDataFields = ServiceDataFields;
}
